/// <amd-module name="WidgetCommon/WorkItemResultsGrid/WorkItemResultsGrid.Props" />
import { WidgetProps, WidgetSize } from "Dashboards/WidgetContracts/WidgetProps";
import { QueryType, WorkItemFieldReference, WorkItemLink } from "Wit/Clients/Wit/Contracts/WorkItemTracking";

/** A widgets-centric wrapper around WIT UI Work Item Results Grid. */
export interface WorkItemResultsGridProps {
    // Optional Guid used for storing user defined column width settings. If not specified, then persistent settings will not be supported.
    storageId?: string;
    // Title text for the visual.
    title: string;

    // List of columns to be displayed by the grid.
    columns: WorkItemFieldReference[];

    // List of IDs for work items to be displayed by the grid.
    itemsSource: number[];

    /**
     * Hierarchical relations between work items.
     */
    workItemRelations?: WorkItemLink[];

    queryType: QueryType;

    // ID of the current context project.
    projectId: string;

    // Widget Information for collecting telemetry
    widgetPropsForTelemetry: WidgetProps;

    // Width and height of the widget.
    size: WidgetSize;

    // Number indicating the 'no results found' image to be displayed if there are no work items.
    noDataCardId?: number;

    /**
     * Boolean indicating whether to display work item type filter
     * @default false
     */
    showVisualFilters?: boolean;

    /**
     * When a title link is clicked or row is activated, this property indicates how the work item should be shown.
     */
    openWorkItemBehavior: OpenWorkItemBehavior;
    
    /**
     * Optional property to specify the number of work items to fetch per request.
     */
    pageSize?: number;
}
export const enum OpenWorkItemBehavior {
    /** Opens the work item in a modal work item dialog */
    Dialog,
    /** Opens the work item in a new tab */
    NewTab
}
